import { apiClient } from './client'

export interface BackupSettings {
  git_url: string | null
  public_key: string | null
}

export interface JobStatus {
  kind: 'backup' | 'restore'
  state: 'idle' | 'running' | 'success' | 'error'
  message: string
  started_at: string | null
  finished_at: string | null
}

export const getBackupSettings = () =>
  apiClient.get<BackupSettings>('/backup/settings')

export const saveBackupSettings = (data: { git_url: string }) =>
  apiClient.put<BackupSettings>('/backup/settings', data)

// Backup und Restore starten nur einen Hintergrund-Job und antworten sofort;
// das Ergebnis kommt über getBackupJobStatus. Dadurch hängt die Laufzeit eines
// Backups nicht mehr am Timeout des Browsers oder des Reverse Proxy.
export const runBackup = () => apiClient.post<JobStatus>('/backup/run')

export const runRestore = () => apiClient.post<JobStatus>('/backup/restore')

export const getBackupJobStatus = () => apiClient.get<JobStatus>('/backup/status')

export const changePassword = (data: { current_password: string; new_password: string }) =>
  apiClient.put<{ message: string }>('/auth/password', data)

export type OcrProvider = 'tesseract' | 'google_cloud_vision' | 'mistral'

export interface OcrSettings {
  provider: OcrProvider
  google_cloud_vision_api_key_set: boolean
  mistral_api_key_set: boolean
}

export interface OcrSettingsInput {
  provider: OcrProvider
  google_cloud_vision_api_key?: string
  mistral_api_key?: string
}

export const getOcrSettings = () =>
  apiClient.get<OcrSettings>('/ocr/settings')

export const saveOcrSettings = (data: OcrSettingsInput) =>
  apiClient.put<OcrSettings>('/ocr/settings', data)

export type AISearchProvider = 'anthropic' | 'mistral'

export interface AIStatus {
  configured: boolean
  provider: AISearchProvider
}

export const getAIKeyStatus = () =>
  apiClient.get<AIStatus>('/search/ai-key')

export const saveAIKey = (key: string) =>
  apiClient.put<AIStatus>('/search/ai-key', { key })

export const deleteAIKey = () =>
  apiClient.delete<AIStatus>('/search/ai-key')

export const saveAIProvider = (provider: AISearchProvider) =>
  apiClient.put<AIStatus>('/search/ai-provider', { provider })
